var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnordered = function SvgUnordered(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "currentColor",
    style: {
      color: "#6a89a6"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.984 11a.89.89 0 0 1 .891-.89h10a.89.89 0 0 1 0 1.78h-10a.89.89 0 0 1-.89-.89Zm.891 4.11h10a.89.89 0 0 1 0 1.78h-10a.89.89 0 0 1 0-1.78Zm0 5h10a.89.89 0 0 1 0 1.78h-10a.89.89 0 0 1 0-1.78ZM8.769 15a1.203 1.203 0 1 1 1.337 2 1.203 1.203 0 0 1-1.337-2Zm0-5a1.203 1.203 0 1 1 1.337 2 1.203 1.203 0 0 1-1.337-2Zm0 10a1.203 1.203 0 1 1 1.337 2 1.203 1.203 0 0 1-1.337-2Z"
  })));
};
export default SvgUnordered;